import {
    observable,
    action,
    // computed,
    // makeObservable,
    makeAutoObservable
} from 'mobx';

import { getCurrentUserInfo } from 'src/api/login';

export class UserStore {
    @observable userInfo = { authToken: '', userType: '', username: '' };

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    @action
    setUserInfo(user: any) {
        this.userInfo = user;
    }

    @action
    async getUserInfo() {
        const data = await getCurrentUserInfo();
        this.setUserInfo(data.data);
    }
}
export default UserStore;
